import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes'; // Necesitarás crear este archivo
import { authInterceptor } from './Common/Interceptors/auth.interceptor';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// IMPORTANTE: Registrar los datos de cultura para español
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    { 
      provide: MAT_DATE_LOCALE, 
      useFactory: (locale: string) => locale, 
      deps: [LOCALE_ID] 
    }
  ]
};